import {Injectable} from '@angular/core';
import {Http, Headers, Response, RequestOptions} from '@angular/http';

import {Observable} from "rxjs/Observable";
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/combineLatest';

import {BehaviorSubject} from "rxjs/BehaviorSubject";
import {Admin} from "./admin";
import {Router} from "@angular/router";


@Injectable()
export class AuthService {
  public currentAdmin$: BehaviorSubject<Admin> = new BehaviorSubject<Admin>(null);

  constructor(private http: Http, private router: Router) {
    //load currentAdmin
    var currentAdmin = JSON.parse(localStorage.getItem('currentAdmin'));
    if (currentAdmin && currentAdmin.admin) {
      //console.log("admin loaded");
      this.currentAdmin$.next(currentAdmin.admin);
    }

    //Save new currentAdmin
    this.currentAdmin$.subscribe(
      admin => {
        //console.log("Save new admin: ", admin);
        localStorage.setItem('currentAdmin', JSON.stringify({admin: admin}));
      }
    );
  }

  public update(): void {
    this.fetchCurrentAdmin();
  }

  protected fetchCurrentAdmin(): void {
    //console.log("fetchCurrentAdmin");
    this.http.get('/api/admin/current').subscribe(
      res => {
        //console.log("fetchCurrentAdmin", res);
        let response = res.json();
        let admin: Admin = response.admin;
        this.currentAdmin$.next(admin);
      },
      err => {
        console.error("Fetching admin failed. Error:", err);
        this.currentAdmin$.next(null);
      }
    );
  }

  isLoggedIn() {
    return this.currentAdmin$ && this.currentAdmin$.value;
  }

  loginWithLocalAccount(username: string, password: string): Observable < boolean > {
    //console.log("Try to login. ");
    let body = JSON.stringify({username: username, password: password});
    let headers = new Headers({'Content-Type': 'application/json'});
    let options = new RequestOptions({headers: headers});

    return this.http.post('api/auth/login', body, options)
      .map((response: Response) => {
        let data = response.json();
        let admin: Admin = data.admin;
        this.currentAdmin$.next(admin);
        this.router.navigate(['/welcome']);
        return true;
      })
      .catch(this.handleError);
  }

  logout(): Observable < Response > {
    // clear token remove user from local storage to log user out
    console.log("Try to logout.");
    this.currentAdmin$.next(null);
    return this.http.get('api/auth/logout')
      .catch(this.handleError);
  }

  private handleError(error: Response | any) {
    // In a real world app, you might use a remote logging infrastructure
    let errMsg: string;
    if (error instanceof Response) {
      const body = error.json() || '';
      const err = body.error || JSON.stringify(body);
      errMsg = `${error.status} - ${error.statusText || ''} ${err}`;
    } else {
      errMsg = error.message ? error.message : error.toString();
    }
    console.error(errMsg);
    return Observable.throw(errMsg);
  }

  saveAdmin(admin: Admin) : Observable<boolean> {
    let body = JSON.stringify({admin: admin});
    let headers = new Headers({'Content-Type': 'application/json'});
    let options = new RequestOptions({headers: headers});

    return this.http.put("api/admin/", body, options)
      .map(res => {
        let data = res.json();
        if (data.status && data.status == "Success") {
          if (data.admin) {
            //console.log("new admin data!");
            this.currentAdmin$.next(data.admin);
          }
          else {
            console.log("Warning: responce had no admin");
          }
          return true;
        }
        return false;
      })
      .catch(this.handleError);
  }

  createAdmin(name: string, password: string) : Observable<boolean> {
    let body = JSON.stringify({name: name, password: password});
    let headers = new Headers({'Content-Type': 'application/json'});
    let options = new RequestOptions({headers: headers});

    return this.http.post("api/admin/new", body, options)
      .map(res => {
          return true;
        }
      )
      .catch(this.handleError)
  }
}



// WEBPACK FOOTER //
// ./src/app/auth.service.ts